import http from '@/services/http';

const workPlanning = {
  attachmentsZip({ where, analysisCode }) {
    return http.request({
      method: 'get',
      url: '/samples/attachments-zip',
      params: { where, analysisCode },
      responseType: 'blob',
    });
  },
  labelsPdf({ where, analysisCode, print }) {
    return http.request({
      method: 'get',
      url: '/samples/labels-pdf',
      params: { where, analysisCode, print },
      responseType: 'blob',
    });
  },
  materialsPdf({ where, analysisCode, print }) {
    return http.request({
      method: 'get',
      url: '/samples/materials-pdf',
      params: { where, analysisCode, print },
      responseType: 'blob',
    });
  },
  // enqueue a job, poll its status until it finishes
  materialsPdfBulkEnqueue({
    where,
    print = true,
    batchSize,
    analysisCode,
    analysisCommodityCode,
  }) {
    return http.request({
      method: 'get',
      url: '/samples/materials-pdf-bulk',
      params: {
        where,
        print,
        ...(batchSize != null && { batchSize }),
        ...(analysisCode && { analysisCode }),
        ...(analysisCommodityCode && { analysisCommodityCode }),
      },
    });
  },
  materialsPdfBulkStatus(jobId) {
    return http.request({
      method: 'get',
      url: `/samples/materials-pdf-bulk/${jobId}`,
    });
  },
  // Work program generation is async: enqueue a job, poll its status, then
  // stream the finished pdf. Large orders (many groupings) used to time out the
  // single synchronous request.
  workProgramPdfEnqueue({ where, analysisCode }) {
    return http.request({
      method: 'get',
      url: '/samples/work-program-pdf-async',
      params: { where, analysisCode },
    });
  },
  workProgramPdfStatus(jobId) {
    return http.request({
      method: 'get',
      url: `/samples/work-program-pdf-async/${jobId}`,
    });
  },
  workProgramPdfDownload(jobId) {
    return http.request({
      method: 'get',
      url: `/samples/work-program-pdf-async/${jobId}/download`,
      responseType: 'blob',
    });
  },
};

export default workPlanning;
